import { post, get } from '../../../services/request';

export const fetchShifts = (payload) => post('Schedule/GetShifts', payload);

export const fetchScheduleDropdowns = () =>
    Promise.all([
        get('Radiologist/GetAllRadiologistQgendaScheduleEnterpriseDropdown').catch(() => ({ values: {} })),
        get('WorkList/GetAllWorkList').catch(() => ({ values: {} })),
        get('Site/GetAllSite').catch(() => ({ values: {} })),
        get('State/GetAllState').catch(() => ({ values: {} })),
        get('Task/GetAllTask').catch(() => ({ values: {} })),
    ]);

export const saveShift = (payload) => post('Schedule/SaveShift', payload);
export const saveShiftBulk = (payload) => post('Schedule/SaveShiftBulk', payload);
export const deleteShift = (shiftId) => post('Schedule/DeleteShift', { ShiftInputDetailID: shiftId });
export const updateShiftGroup = (payload) => post('Schedule/UpdateShiftGroup', payload);
export const swapShift = (payload) => post('Schedule/SwapShift', payload);
export const swapShiftGroup = (payload) => post('Schedule/SwapShiftGroup', payload);
export const deleteShiftGroup = (payload) => post('Schedule/DeleteShiftGroup', payload);
export const updateShiftNotes = (shiftId, notes) =>
    post('Schedule/UpdateNotes', { ShiftInputDetailID: shiftId, Notes: notes });
export const getShiftPrivileges = (radiologistId, asOfDate) =>
    get(`Schedule/GetPrivileges?RadiologistID=${radiologistId}&AsOfDate=${asOfDate}`);
export const getRadAssociatedSites = (radiologistId, asOfDate) =>
    get(`Schedule/GetRadAssociatedSites?RadiologistID=${radiologistId}&AsOfDate=${asOfDate}`);
